module.exports = __webpack_public_path__ + "static/media/3S.471f3e59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3S.svg
// module id = 60
// module chunks = 0